'use strict';

exports.getCallback = function (args, symbol, map) {
  var callback = args[args.length - 1];

  if (typeof callback !== 'function') {
    var promise = new Promise(function (resolve, reject) {
      args.push(callback = function callback(err) {
        for (var _len = arguments.length, results = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          results[_key - 1] = arguments[_key];
        }

        if (err) reject(err);else resolve(map ? map.apply(void 0, results) : results[0]);
      });
    });
    callback[symbol] = promise;
  }

  return callback;
};